import { useContext, useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import InputText from '../../components/common/InputText'
import Button from '../../components/common/Button'
import { NavContext } from '../../context/global_context'
import { getSessionStorageData } from '../../utils/SessionStorage'
import { createSearchParams } from 'react-router-dom'
import useDebouncedValue from '../../utils/common_function'
import { getRequest } from '../../services/base'
import SelectInput from '../common/SelectInput'
import NoRecordsFound from '../common/NoRecordsFound'
import Pagination from '../common/Pagination'
import UsageReportRow from './usage_report_row'

const UsageReport = () => {
  const [state, dispatch] = useContext(NavContext)

  const [selectedUsers, setSelectedUsers] = useState([])
  const [models, setModels] = useState([])
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  )
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10))
  const [vehicle, setVehicle] = useState(null)
  const [vehicleOptions, setVehicleOptions] = useState([])

  const [searchVehicles, setSearchVehicles] = useState('')
  const debouncedToSearchVehicles = useDebouncedValue(searchVehicles, 1000)

  const [userOptions, setUserOptions] = useState([])
  const [searchUser, setSearchUser] = useState('')
  const debouncedToSearchUser = useDebouncedValue(searchUser, 1000)

  const [actionFilters, setActionFilters] = useState({})
  const [actions, setActions] = useState([])
  const [actionTypes, setActionTypes] = useState([])

  const [reportsData, setReportsData] = useState([])
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const currentUrl = useRef(`/api/report/usage/`)

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Usage Report',
        sub_header: 'Can be see usage report here',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getActionAndModelOptions()
  }, [])

  useEffect(() => {
    getVehiclesList(searchVehicles)
  }, [debouncedToSearchVehicles])

  useEffect(() => {
    getUserOptions(searchUser)
  }, [debouncedToSearchUser])

  const getVehiclesList = async (search = '') => {
    let res = await getRequest(`/api/vehicles/?search=${search}`)
    setVehicleOptions(res?.results)
  }

  const getUserOptions = async (search = '') => {
    let res = await getRequest(`/api/users/?search=${search}&is_active=true`)
    setUserOptions(res?.results)
  }

  const getActionAndModelOptions = async () => {
    let res = await getRequest(`/api/report/usage/options/`)
    setActionFilters(res?.data)
  }

  const getReportsData = async (e) => {
    e?.preventDefault()
    let response = await getRequest(currentUrl.current)
    setReportsData(response.results)
    setPagination(response.pagination)
  }

  return (
    <div
      className="flex flex-col py-3 space-y-6 w-full"
      style={{ padding: '16px 12%' }}
    >
      <form
        onSubmit={(e) => {
          currentUrl.current = `/api/report/usage/?vehicle=${vehicle?.vehicle_id ? vehicle?.vehicle_id : ''}&users=${selectedUsers?.map((item) => item.id).join(',')}&content_type=${actionTypes?.map((item) => item.name).join(',')}&activity_type=${actions?.map((item) => item.id).join(',')}&from_date=${fromDate}&to_date=${toDate}`
          getReportsData(e)
        }}
      >
        <div className="flex flex-col justify-between items-center text-white bg-tracer-dark-blue rounded py-3 px-6">
          <div className="flex space-x-4 items-center w-full">
            <InputText
              name="name"
              placeholder={`From Date`}
              className={`w-full`}
              value={fromDate}
              isFullSize={true}
              type="date"
              onChange={(value) => {
                setFromDate(value)
              }}
              isRequired={true}
              wrapperClass={`pl-0`}
              isDefaultValue={true}
              key={`from-date`}
              label={'From Date'}
            />
            <InputText
              name="name"
              placeholder={`To Date`}
              className={`w-full`}
              value={toDate}
              isFullSize={true}
              type="date"
              onChange={(value) => {
                setToDate(value)
              }}
              isRequired={true}
              wrapperClass={`pl-0`}
              isDefaultValue={true}
              key={`to-date`}
              label={'To Date'}
            />
            <SelectInput
              options={vehicleOptions}
              label={`Select Make Model`}
              optionLabel="name"
              optionValue="id"
              placeholder={`Select Make Model`}
              onInputChange={(value) => {
                setSearchVehicles(value)
              }}
              isMulti={false}
              name="make_models"
              onChange={(value) => {
                setVehicle(value)
              }}
              value={vehicle}
            />
          </div>
          <div className="flex space-x-4 items-end w-full">
            <SelectInput
              options={userOptions}
              label={`Select Users`}
              optionLabel="email"
              optionValue="id"
              placeholder={`Select Users`}
              onInputChange={(value) => {
                setSearchUser(value)
              }}
              isMulti={true}
              name="user"
              onChange={(value) => {
                setSelectedUsers(value)
              }}
              value={selectedUsers}
              isRequired={false}
            />
            <SelectInput
              options={actionFilters?.activity_type}
              label={`Select Actions`}
              optionLabel="name"
              optionValue="id"
              placeholder={`Select Actions`}
              name="actions"
              onChange={(value) => {
                setActions(value)
              }}
              value={actions}
              isRequired={false}
              isMulti={true}
            />
            <SelectInput
              options={actionFilters?.content_type}
              label={`Select Reference`}
              optionLabel="name"
              optionValue="id"
              placeholder={`Select Reference`}
              name="action_type"
              onChange={(value) => {
                setActionTypes(value)
              }}
              value={actionTypes}
              isRequired={false}
              isMulti={true}
            />
            <div className="p-2">
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                text={'See Usage Report'}
                onClick={() => {}}
              />
            </div>
          </div>
        </div>
      </form>

      <div>
        <div className="font-light">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
            <div className="w-3/12 pl-10">Date</div>
            <div className="w-3/12">User</div>
            <div className="w-6/12">Activity</div>
            {/* <div className="w-2/12">Activity Type</div> */}
          </div>
        </div>

        {reportsData?.map((report, reportIdx) => {
          return <UsageReportRow {...report} key={`report-${reportIdx}`} />
        })}

        {reportsData?.length < 1 && (
          <NoRecordsFound caption={'Usage Not Exists'} loading={false} />
        )}
        <div className="py-6">
          <Pagination
            context={pagination}
            onClickNext={(e) => {
              currentUrl.current = e
              getReportsData()
            }}
            onClickPrev={(e) => {
              currentUrl.current = e
              getReportsData()
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default UsageReport
